
import { DaButton } from '@daiso/design-system'
export default {
  name: 'PageInfo',
  components: { DaButton },
  props: {
    infoText: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    infoIcon: {
      type: String,
      default: 'check'
    },
  },
  methods: {
    reContents (text) {
      return text.split('\n')
    },
  }
}
